import {onFind} from "@elements/init-modules-in-scope";
import {getPrefixedDataSet} from "@elements/data-set-utils";
import {findIn} from "@elements/dom-utils";
import {getConfigValue} from "@elements/config-utils";
import loadScript from "@elements/load-script";

export function init () {
    function initOA( oamaps, $map) {
        let layerConfig = (oa.PREFIX === 'oam') ? null : {
            markersActive : true,
            defaultIW : true
        };

        // initialize GeomLayer
        let layer = new oamaps.GeomLayer( _config.outdoorActive.tourId, layerConfig );

        let h = layer.listen('markerClick', storeMarkerInfos);
        let w = layer.listen('iwSelect', openDetailPage);

        layer.whenLoaded( function () {
            let mapTypeIds = ['oa_map', 'oa_topo', 'oa_map_winter' ];

            let mapConfig = {
                bounds: layer.getBounds(),
                mapTypeId : mapTypeIds[ 0 ],
                mapTypeControlOptions : { mapTypeIds: mapTypeIds }
            };


            let map = oamaps.map( $map, mapConfig );

            // add GeomLayer to map
            layer.setMap( map );
        });

    }


    onFind('.js-oa-map', function ($container) {
        console.log('oamap load');
        loadMapsAPI().then(() => {
            if ($container) {
                oax.api.maps(function (maps) {
                    initOA(maps, findIn('.js-oa-map__canvas', $container));
                });
            }
        });
    });
}

let promise;
export default function loadMapsAPI() {
    if (promise) {
        return promise;
    }

    promise = new Promise((resolve, reject) => {
        if (!_config.outdoorActive) {
            console.warn('Could not load outdoor map because _cfg.outdoorActive was not set.');
            _config.outdoorActive.key = 'yourtest-outdoora-ctiveapi'; /*dev test key*/
        }

        window.mapApiLoadedCallback = function () {
            resolve();
        };

        loadScript('https://www.outdooractive.com/alpportal/oax_head.js?proj='+ _config.outdoorActive.project +'&key=' + _config.outdoorActive.key + '&callback=window.mapApiLoadedCallback&use_gmap=0&leaflet_gshim=1&lang=' + _config.lang + '&');
    });

    return promise;

}

function storeMarkerInfos(obj){
    let title = obj.title;
    title = title.replace(/\s+/g, '-').toLowerCase();
    localStorage.setItem('OaMarkerTitle', title);
    localStorage.setItem('OaMarkerId', obj.id);
    localStorage.setItem('OaMarkerType', obj.type);
}
function openDetailPage(obj){
    try{
        let title = localStorage.getItem('OaMarkerTitle');
        let id = localStorage.getItem('OaMarkerId');
        let type = localStorage.getItem('OaMarkerType');

        if(_config.outdoorActivePoiUrls !== undefined && _config.outdoorActivePoiUrls[id] ){
            return window.open(_config.outdoorActivePoiUrls[id]);
        }else if(obj.id === id){
            //fallback old oa link
            return window.open("https://www.outdooractive.com/de/" + type + "/schweiz/" + title + "/" + id, '_blank') ;
        }else{
            console.log('IWSelect ID not the same as Local Storage', obj.id, id);
            return null;
        }
    }catch(e){
        console.log('local storage error', e);
    }
}